import { withInstall, withNoopInstall } from '@lit-element/utils'

import Container from './src/container.vue'
import Aside from './src/aside.vue'
import Footer from './src/footer.vue'
import Header from './src/header.vue'
import Main from './src/main.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtContainer: SFCWithInstall<typeof Container> & {
  Aside: typeof Aside
  Footer: typeof Footer
  Header: typeof Header
  Main: typeof Main
} = withInstall(Container, {
  Aside,
  Footer,
  Header,
  Main,
})

export default LtContainer
export const LtAside: SFCWithInstall<typeof Aside> = withNoopInstall(Aside)
export const LtFooter: SFCWithInstall<typeof Footer> = withNoopInstall(Footer)
export const LtHeader: SFCWithInstall<typeof Header> = withNoopInstall(Header)
export const LtMain: SFCWithInstall<typeof Main> = withNoopInstall(Main)

export type ContainerInstance = InstanceType<typeof Container>
export type AsideInstance = InstanceType<typeof Aside>
export type FooterInstance = InstanceType<typeof Footer>
export type HeaderInstance = InstanceType<typeof Header>
export type MainInstance = InstanceType<typeof Main>
